import {post, postfile, downFile} from './http'
const baseUrl = '/api/admin/mkcenter/distribute/config'
// 获取分销状态
export const getDistributionStatus = v => post(`${baseUrl}/getHostShopDistributeConfigStatus`, v.data, v.success, v.error)
// 开启关闭店铺分销
export const openCloseDistribution = v => post(`${baseUrl}/updateHostShopDistributeStatus`, v.data, v.success, v.error)
// 更新店铺分销设置
export const updatedDistributionSetting = v => post(`${baseUrl}/updateHostShopDistributeConfig`, v.data, v.success, v.error)
// 获取店铺分销设置
export const getDistributionMsg = v => post(`${baseUrl}/getHostShopDistributeConfig`, v.data, v.success, v.error)
// 获取商品设置分页列表
export const getCommoditySetList = v => post(`${baseUrl}/getHostShopDistributeGoodPageList`, v.data, v.success, v.error)
// 获取商品佣金比例设置
export const getCommodityProportion = v => post(`${baseUrl}/getHostShopDistributeGoodBrokerageScope`, v.data, v.success, v.error)
// 获取自定义海报模板列表
export const getPosterModelList = v => post(`${baseUrl}/getHostShopDistributeCustomPosterList`, v.data, v.success, v.error)
// 商品佣金比例设置
export const commodityProportionSet = v => post(`${baseUrl}/addOrUpdateHostShopDistributeGoodBrokerageScope`, v.data, v.success, v.error)
// 新增或编辑自定义海报模板
export const addEditPosterModel = v => post(`${baseUrl}/addOrUpdateHostShopDistributeCustomPoster`, v.data, v.success, v.error)
// 删除自定义海报模板
export const deletePosterModel = v => post(`${baseUrl}/deleteHostShopDistributeCustomPoster`, v.data, v.success, v.error)
// 获取系统默认的海报设置
export const getDefaultPosterSet = v => post(`${baseUrl}/getDefaultHostShopDistributeCustomPoster`, v.data, v.success, v.error)